import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -1.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
    <g transform="translate(17.400000,72.200000) scale(0.100000,-0.100000)">
      <path
        d="M120 236 l0 -156 30 0 c30 0 30 1 30 55 0 54 1 55 28 55 24 0 32 -8
      55 -55 22 -44 32 -55 51 -55 37 0 39 13 10 73 l-26 54 26 26 c34 34 35 85 2
      124 -23 26 -30 28 -115 31 l-91 4 0 -156z m155 79 c9 -13 10 -28 4 -42 -7 -19
      -16 -23 -54 -23 l-45 0 0 46 0 45 41 -3 c29 -2 46 -9 54 -23z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconLogo;
